import styled from 'styled-components';

import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

export const CardWrapper = styled.div`
  position: absolute;
  top: 128px;
  left: 0;
  right: 0;
  max-width: 700px;
  height: auto;
  z-index: 5555;
  padding: 24px 18px;
  background: ${COLOR.WHITE_1};
  box-shadow: 0px 2px 6px rgb(0 0 0 / 45%);
  border-radius: 6px;
  margin: 0 18px;

  h3 {
    width: 90%;
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
  }

  .MuiIconButton-root {
    position: absolute;
    top: 0;
    right: 0;
  }

    /* Tablet-Notebook */
    @media screen and (min-width: ${BREAKPOINT.MD}) {
      max-width: 580px;
      margin: auto;
      padding: 44px 32px;


      p {
        font-size: 16px;
      }
    }
`;

export const BoxLinkShare = styled.section`
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #FDFDFF;
    border: 1px solid #C8CBD4;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 0;
    margin-top: 18px;

    p {
      width: 65%;
      margin: 11px 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    button {
      width: 35%;
      height: 100%;
      margin: 0 -1px;
      border-radius: 0 6px 6px 0;
    }

    /* Tablet-Notebook */
    @media screen and (min-width: ${BREAKPOINT.MD}) {
      height: 40px;
      margin-top: 32px;
    }
`;
